var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app"},[_c('keep-alive',{attrs:{"include":_vm.include,"max":30}},[_c('router-view',{ref:"router",staticClass:"router"})],1)],1),(_vm.footer === true || _vm.movieFooter === true || _vm.festivalFooter === true || _vm.bookFooter === true)?_c('Footer'):_vm._e(),(_vm.home === true)?_c('Home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }